
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import apparelIcon from '../../../images/insight360/360-apparel-icon.png';
import autoIcon from '../../../images/insight360/360-auto-icon.png';
import cellphonesIcon from '../../../images/insight360/360-cellphones-icon.png';
import consumerPrivacyIcon from '../../../images/insight360/360-consumer-privacy-icon.png';
import dietHealthIcon from '../../../images/insight360/360-diet-health-icon.png';
import environmentIcon from '../../../images/insight360/360-environment-icon.png';
import foodIcon from '../../../images/insight360/360-food-icon.png';
import healthMedsIcon from '../../../images/insight360/360-health-meds-icon.png';
import internetIcon from '../../../images/insight360/360-internet-icon.png';
import mediaIcon from '../../../images/insight360/360-media-icon.png';
import personalFinanceIcon from '../../../images/insight360/360-personal-finance-icon.png';
import prodPlcmntMoviesIcon from '../../../images/insight360/360-prod-plcmnt-movies-icon.png';
import prodPlcmntTvIcon from '../../../images/insight360/360-prod-plcmnt-tv-icon.png';
import shoppingIcon from '../../../images/insight360/360-shopping-icon.png';
import shoppingBehaviorIcon from '../../../images/insight360/360-shopping-behavior-icon.png';
import socInteractionIcon from '../../../images/insight360/360-soc-interaction-icon.png';
import socialMediaIcon from '../../../images/insight360/360-social-media-icon.png';
import techIcon from '../../../images/insight360/360-tech-icon.png';
import travelIcon from '../../../images/insight360/360-travel-icon.png';
import videoGameIcon from '../../../images/insight360/360-video-game-icon.png';
import homeIcon from '../../../images/insight360/360-home-icon.png';
import healthBeautyIcon from '../../../images/insight360/360-health-beauty-icon.png';
import diningIcon from '../../../images/insight360/360-dining-icon.png';
import cleaningProductsIcon from '../../../images/insight360/360-cleaning-products-icon.png';
import spanishIcon from '../../../images/insight360/360-spanish-language-icon.png';
import printMediaIcon from '../../../images/insight360/360-print-media-icon.png';
import petsIcon from '../../../images/insight360/360-pets-icon.png';
import lifestyleIcon from '../../../images/insight360/360-lifestyle-icon.png';
import tobaccoIcon from '../../../images/insight360/360-tobacco-icon.png';
import generalIcon from '../../../images/insight360/360-general-icon.png';
import downArrowIcon from '../../../images/insight360/down-arrow-icon.png';
import upArrowlIcon from '../../../images/insight360/up-arrow-icon.png';
import cultureLifestyleIcon from '../../../images/insight360/360-lifestyle-icon.png';
import languageMediaIcon from '../../../images/insight360/360-media-icon.png';

// Mri Icons
import mriBuyingStyleIcon from '../../../images/mri-icons/360-mri-buying-style-icon.png';
import mriFinanceIcon from '../../../images/mri-icons/360-mri-finance-icon.png';
import mriFashionIcon from '../../../images/mri-icons/360-mri-fashion-icon.png';
import mriFoodIcon from '../../../images/mri-icons/360-mri-food-icon.png';
import mriGeneralIcon from '../../../images/mri-icons/360-mri-general-icon.png';
import mriHealthIcon from '../../../images/mri-icons/360-mri-health-icon.png';
import mriInternetIcon from '../../../images/mri-icons/360-mri-internet-icon.png';
import mriTvWatchingIcon from '../../../images/mri-icons/360-mri-tv-watching-icon.png';
import mritravelIcon from '../../../images/mri-icons/360-mri-travel-icon.png';
import mriAutoIcon from '../../../images/mri-icons/360-mri-auto-icon.png';
import mriTechIcon from '../../../images//mri-icons/360-mri-tech-icon.png';
import mriPoliticalEngagementIcon from '../../../images//mri-icons/360-mri-political-outlook-icon.png';
import customIcon from '../../../images/insight360/360-custom-icon.png';
import mriCustomIcon from '../../../images//mri-icons/360-mri-custom-icon.png';


const iconComponents = [
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360ConsumerPrivacyIcon', selectedIcon: consumerPrivacyIcon },
  { id: '360DietHealthIcon', selectedIcon: dietHealthIcon },
  { id: '360EnvironmentIcon', selectedIcon: environmentIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthMedsIcon },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360MediaIcon', selectedIcon: mediaIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: prodPlcmntMoviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: prodPlcmntTvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360ShoppingBehaviorIcon', selectedIcon: shoppingBehaviorIcon },
  { id: '360SocInteractionIcon', selectedIcon: socInteractionIcon },
  { id: '360SocialMediaIcon', selectedIcon: socialMediaIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360VideoGameIcon', selectedIcon: videoGameIcon },
  { id: '360TobaccoIcon', selectedIcon: tobaccoIcon },
  { id: '360LifestyleIcon', selectedIcon: lifestyleIcon },
  { id: '360PetsIcon', selectedIcon: petsIcon },
  { id: '360PrintMediaIcon', selectedIcon: printMediaIcon },
  { id: '360SpanishLanguageIcon', selectedIcon: spanishIcon },
  { id: '360CleaningProductsIcon', selectedIcon: cleaningProductsIcon },
  { id: '360DiningIcon', selectedIcon: diningIcon },
  { id: '360HealthBeautyIcon', selectedIcon: healthBeautyIcon },
  { id: '360HomeIcon', selectedIcon: homeIcon },
  { id: '360GeneralIcon', selectedIcon: generalIcon },
  { id: '360MriFoodIcon', selectedIcon: mriFoodIcon },
  { id: '360MriBuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360MriFinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360MriFashionIcon', selectedIcon: mriFashionIcon },
  { id: '360MriGeneralIcon', selectedIcon: mriGeneralIcon },
  { id: '360MriHealthIcon', selectedIcon: mriHealthIcon },
  { id: '360MriInternetIcon', selectedIcon: mriInternetIcon },
  { id: '360MriTvWatchingIcon', selectedIcon: mriTvWatchingIcon },
  { id: '360MriTravelIcon', selectedIcon: mritravelIcon },
  { id: '360MriAutoIcon', selectedIcon: mriAutoIcon },
  { id: '360MriTechIcon', selectedIcon: mriTechIcon },
  // { id: '360MriPoliticalOutlookIcon', selectedIcon: mriPoliticalOutlookIcon },
  { id: '360MriPoliticalEngagementIcon', selectedIcon: mriPoliticalEngagementIcon },
  { id: '360MriCustomIcon', selectedIcon: mriCustomIcon },
  { id: '360CustomIcon', selectedIcon: customIcon },
  { id: '360CultureLifestyleIcon', selectedIcon: cultureLifestyleIcon },
  { id: '360LanguageMediaIcon', selectedIcon: languageMediaIcon },
];

class NotableCharacterDetails extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(iconComponents, { id: imageKey });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }
  render() {
    return (
      <div>
        {this.props.statement !== undefined && (
          <div
            className="attitude-detail-comparision-grid"
          >
            <div className="attitude-comparision-float">
              <div className="attitude-float">
                <div className="attitude-comparision-image-border attitude-float">
                 { this.props.statement.icon === undefined &&
                   <div className="imageblock" />
                }
                  { this.props.statement.icon !== undefined &&
                  <div className="row">
                  { this.getImageIcon(
                    _.camelCase(
                      _.cloneDeep(this.props.statement).icon.replace('.png', ''),
                    ),
                  ) === undefined && <div className="imageblock" />}
                  { this.getImageIcon(
                    _.camelCase(
                      _.cloneDeep(this.props.statement).icon.replace('.png', ''),
                    ),
                  ) !== undefined && (
                      <img
                        alt=""
                        className="i360-demo-double-comparision-img"
                        src={this.getImageIcon(
                          _.camelCase(
                            _.cloneDeep(this.props.statement).icon.replace('.png', ''),
                          ),
                        )}
                      />
                    )}
                    </div>
                }
                  <div className="attitude-comparision-icon-labels">
                    {this.props.statement.category}{' '}
                  </div>
                </div>
              </div>
              <div className="profile-matrix-container">
                <div className="div-overflow">
                  <div
                    className="attitude-comparision-labels"
                    title={_.upperCase(this.props.statement.text)}
                  >
                    <p className="brand-block-with-text">
                      {_.upperCase(this.props.statement.text)}
                    </p>
                  </div>
                </div>
                <div className="div-overflow">
                  <div className="attitude-triple-comparision-metrics profile-matrix-push-down">
                    <p className="profile-matrix-padding">
                      INDEX:&nbsp;&nbsp;
                      <span
                        style={{ color: (this.props.statement.index < 100) ? '#ee3232' : '#00b400' }}
                      >
                        {this.props.statement.index}
                      </span>
                      <img
                        alt=""
                        className="notableCharacter-arrow"
                        src={(this.props.statement.index < 100) ? downArrowIcon : upArrowlIcon}
                      />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

NotableCharacterDetails.propTypes = {
  statement: PropTypes.shape({
    category: PropTypes.string,
    text: PropTypes.string,
    index: PropTypes.number,
  }),
};


export default NotableCharacterDetails;

